export const createUserSlice = (set) => ({
  userNm: "",
  setUserNm: (userNm) => {
    set((state) => {
      state.user.userNm = userNm;
    });
  },
  userId: "",
  setUserId: (userId) => {
    set((state) => {
      state.user.userId = userId;
    });
  },
  setUserInfo: (userInfo) => {
    set((state) => {
      state.user = { ...userInfo };
    });
  },
  resetUserInfo: () => {
    set((state) => {
      state.user = {
        userId: "",
        userNm: "",
      };
    });
  },
});

export const createUserAuthListSlice = (set) => ({
  authLists: [],
  setAuthList: (authLists) => {
    set((state) => {
      state.user.authLists = authLists;
    });
  },
});
